import type { ModuleId } from '@tahi/core';
import { singletonId } from '@tahi/core';
import { moduleStates } from '@tahi/db';
import { eq, isNull } from 'drizzle-orm';
import type { LocalDb } from '../localDb';

export type ModuleStateRow = typeof moduleStates.$inferSelect;

/** The Worker requires this id for module_states inserts (conventions §13, §14). */
export const moduleStateId = (userId: string, moduleId: ModuleId): string =>
  singletonId(userId, `module_states.${moduleId}`);

export function listModuleStates(db: LocalDb): Promise<ModuleStateRow[]> {
  return db.select().from(moduleStates).where(isNull(moduleStates.deletedAt)).all();
}

export function getModuleState(db: LocalDb, id: string): Promise<ModuleStateRow | undefined> {
  return db.select().from(moduleStates).where(eq(moduleStates.id, id)).get();
}
